import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapBoundaryWatersCanoeArea from "../components/Maps/boundary-waters-canoe-area";
import BoundaryWatersCanoeAreaInfo from "../components/TripInfo/boundary-waters-canoe-area";

class BoundaryWatersCanoeArea extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Boundary Waters Canoe Area: 5-Day Paddling Trip"
        category="Wilderness"
        slug="boundary-waters-canoe-area-itinerary"
        excerpt="One million acres of Minnesota wilderness — 1,200 lakes connected by portage trails, no motors, no roads, no cell service. Just you, a canoe, and loons at dusk."
        tags={["Wilderness", "Canoeing", "Midwest", "Minnesota", "Camping", "Fishing"]}
        readTime="8 min read"
        mapComponent={<MapBoundaryWatersCanoeArea />}
        whereToStay={[
          { name: 'Outfitter Lodges in Ely', type: 'Outfitter Base Camp · Ely, MN', url: 'https://www.booking.com/searchresults.html?ss=Ely%2C+Minnesota' },
          { name: 'Hotels in Grand Marais', type: 'Lake Superior Town · Grand Marais, MN', url: 'https://www.booking.com/searchresults.html?ss=Grand+Marais%2C+Minnesota' },
          { name: 'Gunflint Trail Cabins', type: 'Remote Cabins · Cook County, MN', url: 'https://www.booking.com/searchresults.html?ss=Cook+County%2C+Minnesota' },
        ]}
      >
        <BoundaryWatersCanoeAreaInfo />
      </StaticPostLayout>
    );
  }
}

export default BoundaryWatersCanoeArea;
